import { FindSimilarAccountsBtn } from "../ui/buttons";
import { GoToActionBlock } from "../products";
import { useGetCampaignSummaryQuery } from "../../api";
import { AnalysisStatus } from "../../types/companyTypes";
import { CampaignPurpose } from "../../types/enums";

type Props = {
  campaign_id: string;
  onSearchStart: () => void;
};

export const RecommendedActionBlock = ({
  campaign_id,
  onSearchStart,
}: Props) => {
  const { data: summary } = useGetCampaignSummaryQuery({ campaign_id });

  const isLoading =
    summary?.recommended_accounts_status === AnalysisStatus.in_progress;
  const isCompleted =
    summary?.recommended_accounts_status === AnalysisStatus.completed;
  const isEverGenerated = summary?.recommended_accounts_status !== "ready";
  const isSampleCampaign = summary?.campaign_purpose !== CampaignPurpose.base;
  const isRegenerationDisabled = isSampleCampaign && isEverGenerated;

  if (isCompleted && (isEverGenerated || isSampleCampaign)) return null;

  if (!isEverGenerated) {
    return (
      <GoToActionBlock
        bgColor={"#F7F7F7"}
        border={"none"}
        title="No similar accounts discovered yet"
        texts={[
          "We haven't found any recommended accounts based on your current targets.",
          "Explore similar accounts to support account expansion.",
        ]}
        btn={
          <FindSimilarAccountsBtn
            isLoading={isLoading}
            isRegenerationDisabled={isRegenerationDisabled}
            onSearchStart={onSearchStart}
          />
        }
      />
    );
  }

  return (
    <GoToActionBlock
      bgColor={"#F7F7F7"}
      border={"none"}
      title="Targeting has been updated"
      texts={[
        "You've made changes to targeting settings. Run a new search to discover recommended accounts",
        "that match the updated criteria.",
      ]}
      btn={
        <FindSimilarAccountsBtn
          isLoading={isLoading}
          isRegenerationDisabled={isRegenerationDisabled}
          onSearchStart={onSearchStart}
        />
      }
    />
  );
};
